import { render, staticRenderFns } from "./OrganisationGouvernance.vue?vue&type=template&id=89235658"
import script from "./OrganisationGouvernance.vue?vue&type=script&lang=js"
export * from "./OrganisationGouvernance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports